import { DeviceVariantType } from './types';

export const BREAKPOINT_QUERIES = {
  [DeviceVariantType.DESKTOP]:
    '(min-width: 1195px) and (orientation: portrait), (min-width: 1377px) and (orientation: landscape)',
  [DeviceVariantType.TABLET]:
    '(min-width: 744px) and (max-width: 1194px) and (orientation: portrait), (min-width: 744px) and (max-width: 1376px) and (orientation: landscape)',
  [DeviceVariantType.MOBILE]: '(max-width: 743px)',
};

export const BREAKPOINT_CONFIG = [
  {
    const: 'XL',
    minWidth: 1280,
  },
  {
    const: 'LG',
    minWidth: 1024,
  },
  {
    const: 'MD',
    minWidth: 768,
  },
  {
    const: 'SM',
  },
];
